import {
  Component,
  signal,
  WritableSignal,
  ElementRef,
  ViewChildren,
  QueryList,
  HostListener,
  inject,
  Renderer2,
  OnInit,
} from '@angular/core';
import { NotificationService } from '../../Services/notification.service';
import { OrderService } from '../../Services/order.service';
import { Observable } from 'rxjs';
import { OrderModel } from '../../models/Customer Order model/order-model.model';
import { LanguageService } from '../../Services/language.service';

@Component({
  selector: 'app-order-page',
  templateUrl: './order-page.component.html',
  styleUrls: ['./order-page.component.scss'],
})
export class OrderPageComponent implements OnInit {
  UserOrders = inject(OrderService);
  Orders$: Observable<OrderModel[]> = this.UserOrders.orders$;
  sum: number = 0;
  totalTitle: WritableSignal<string> = signal('');
  private languageService = inject(LanguageService);
  language = this.languageService.getLanguage();

  
  

  private activeButtonId: string | null = null; // Tracks the active delete button ID
  private startX = 0;
  private swipeThreshold = 200;
  private currentSwipedItem: ElementRef | null = null;

  renderer = inject(Renderer2);
  @ViewChildren('swipeItem') swipeItems!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.UserOrders.orders$.subscribe((orders) => {
      this.calculateSum(orders);
    });
    this.updateTitles();
  }

  onTouchStart(event: TouchEvent, index: number) {
    const touchedItem = this.getTouchedElement(event);
    if (touchedItem) {
      this.currentSwipedItem = touchedItem;
      this.startX = event.touches[0].clientX;
      this.activeButtonId = `delete-btn-${index}`; // Store the unique button id
    }
  }

  onTouchMove(event: TouchEvent, index: number) {
    if (!this.currentSwipedItem) return;

    const currentX = event.touches[0].clientX;
    const deltaX = currentX - this.startX;

    this.renderer.setStyle(
      this.currentSwipedItem.nativeElement,
      'transform',
      `translateX(${deltaX}px)`
    );

    if (deltaX < -this.swipeThreshold && this.activeButtonId) {
      // Reveal the delete button
      const button = document.getElementById(this.activeButtonId);
      if (button) {
        button.classList.remove('hidden'); // Remove the hidden class
      }
    }
  }

  onTouchEnd(index: number) {
    if (!this.currentSwipedItem) return;

    if (this.activeButtonId) {
      const button = document.getElementById(this.activeButtonId);
      if (button) {
        if (
          parseInt(
            this.currentSwipedItem.nativeElement.style.transform.split('(')[1],
            10
          ) < -this.swipeThreshold
        ) {
          this.renderer.setStyle(
            this.currentSwipedItem.nativeElement,
            'transform',
            'translateX(-150px)'
          );
        } else {
          this.resetSwipePosition();
          button.classList.add('hidden'); // Re-hide the delete button if not swiped far enough
        }
      }
    }

    this.currentSwipedItem = null;
    this.activeButtonId = null;
  }

  
  private calculateSum(orders: OrderModel[]) {
    this.sum = orders.reduce((total, order) => {
      return total + order.price * order.amount;
    }, 0); // Start from 0 and calculate the total sum
  }
  
  deleteItem(index: number) {
    this.resetSwipePosition(); // Reset swipe position
    this.activeButtonId = null; // Reset active button ID
    this.UserOrders.removeOrder(index);
  }

  private resetSwipePosition() {
    if (this.currentSwipedItem) {
      this.renderer.setStyle(
        this.currentSwipedItem.nativeElement,
        'transform',
        'translateX(0px)'
      );
    }
  }

  private getTouchedElement(event: TouchEvent): ElementRef | null {
    const target = event.target as HTMLElement;
    return (
      this.swipeItems.find((item) => item.nativeElement.contains(target)) ||
      null
    );
  }

  updateSum() {
    this.UserOrders.orders$.subscribe((orders) => {
      orders.forEach((order) => {
        //console.log(orders);
        this.sum += order.price * order.amount;
      });
    });
  }

  private updateTitles() {
    // Update titles based on the current language in the service
    this.totalTitle = this.languageService.TotalTitle;
    this.language = this.languageService.getLanguage();
  }
}
